'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_AboutPage$State() {
}
export { $c_Lmealorama_pages_AboutPage$State as $c_Lmealorama_pages_AboutPage$State };
$p = $c_Lmealorama_pages_AboutPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_AboutPage$State;
/** @constructor */
function $h_Lmealorama_pages_AboutPage$State() {
}
export { $h_Lmealorama_pages_AboutPage$State as $h_Lmealorama_pages_AboutPage$State };
$h_Lmealorama_pages_AboutPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 80204913;
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_pages_AboutPage$State) || false));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_AboutPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kl)));
}
export { $isArrayOf_Lmealorama_pages_AboutPage$State as $isArrayOf_Lmealorama_pages_AboutPage$State };
var $d_Lmealorama_pages_AboutPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_AboutPage$State, "mealorama.pages.AboutPage$State", ({
  kl: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_AboutPage$State as $d_Lmealorama_pages_AboutPage$State };
//# sourceMappingURL=mealorama.pages.-About-Page$-State.js.map
